var exports = {
  "n": "PerksButton.module__link___NFRleV",
};

module.exports = exports;
